import { useSessionStore as useStore } from "~/client/stores/session";

export default function useSessionStoreAccessor() {
  return useStore.getState;
}
